/* eslint-disable func-names */
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { getCookie, setCookie } from 'utils/cookies';
import { LayoutType } from '../util';

const MWEB_DOCK_CLOSE = 'minitvDmwebClose';
const WEB_DOCK_CLOSE = 'minitvDwebClose';
const WEB_CLOSE = 'minitvwebClose';

// 'mwebminitv', // 0
// 'webminitv', // 1
//'mwebInpage', // 2
// 'webInpage', // 3
// 'mwebLarge', // 4
// 'mwebInpagePip', // 5
// 'mwebPip', // 6
// Dyn time config
const tmplSrc = 'livetv';
export const PLAYER_ICONS = ['bcwd', 'play', 'pause', 'frwd', 'mute', 'unmute'];

export const getOneTimeLayoutBasedConfig = props => {
  const { layoutSsConfig } = props;
  const { layoutType } = layoutSsConfig;
  return {
    headless: [LayoutType[0], LayoutType[1], LayoutType[6]].includes(
      layoutType,
    ),
    initialDock: [LayoutType[1], LayoutType[6]].includes(layoutType),
    webInViewObserver: [LayoutType[3]].includes(layoutType),
  };
};
export const getDynLayoutConfig = layoutType => ({
  nocloseBtn: [LayoutType[2], LayoutType[3]].includes(layoutType),
  isDraggable: [LayoutType[6]].includes(layoutType),
  otControls: [LayoutType[6]].includes(layoutType),
});

export function setClosecookie(isDock, isMobile) {
  if (isDock) {
    const name = isMobile ? MWEB_DOCK_CLOSE : WEB_DOCK_CLOSE;
    setCookie(name, 'y', 1, '/');
  }
  if (!isMobile) {
    setCookie(WEB_CLOSE, 'y', 1, '/');
  }
}

export function updatedLayoutType(props, currentLayoutType, decider) {
  const { layoutSsConfig } = props;

  const { layoutType: layoutTypeSs } = layoutSsConfig;
  const canShiftTo = {
    [LayoutType[4]]: LayoutType[0],
    [LayoutType[3]]: LayoutType[1],
    [LayoutType[5]]: LayoutType[6],
  };
  if (canShiftTo[layoutTypeSs]) {
    if (layoutTypeSs === currentLayoutType && decider) {
      return canShiftTo[layoutTypeSs];
    }
    return layoutTypeSs;
  }
  return null;
}
const getAdSectionName = () => {
  const adSec = `${tmplSrc}_`;
  if (window?.Times?.adsKeys?.Tmpl_SCN === 'home') {
    return `${adSec}hp`;
  }
  return `${adSec}across`;
};

export function getJMinitvConfig(props, layoutSsConfig, layoutConfig) {
  const { layoutType } = layoutSsConfig;
  const { webInViewObserver } = layoutConfig || {};
  const { isMobile, jminiTvData } = props;
  const {
    loadstate = 'expanded', // jarvis setting in case not available
    timeout = 15, // jarvis setting in case not available
    tmplSource = tmplSrc,
  } = jminiTvData;

  let { sticky = true } = jminiTvData; // jarvis setting i
  const skipStickyList = [LayoutType[5], LayoutType[6]];
  const skipSticky = skipStickyList.includes(layoutType);
  const removeMinitv =
    [LayoutType[6]].includes(layoutType) && jminiTvData?.closeSession;
  let cookieLvlClose = false;
  let inViewObserver = webInViewObserver;
  if (skipSticky) {
    sticky = false;
  }
  const cookVal = getCookie(isMobile ? MWEB_DOCK_CLOSE : WEB_DOCK_CLOSE);
  if (cookVal === 'y') {
    sticky = false;
    inViewObserver = false;
    cookieLvlClose = removeMinitv;
  }
  const common = {
    tmplSource,
    loadEventType: 'onload',
    loadeventVal: '',
    ...jminiTvData,
    jActive: cookieLvlClose ? 0 : 1,
  };
  if (isMobile) {
    return {
      ...common,
      inViewObserver: sticky,
      sticky,
      timeout,
    };
  }

  return {
    ...common,
    inViewObserver,
    loadstate,
    timeout: 0,
    newGamAdSection: getAdSectionName(),
  };
}

export function gaSetup(props) {
  const { isMobile } = props;
  return (t, c, e) => {
    // eslint-disable-next-line camelcase
    const { Tmpl_SCN: tmpl, SCN, Channel, SubSCN, LastSubSCN } =
      window?.Times?.adsKeys || {};
    const pl = isMobile ? 'mweb' : 'web';
    let label = `${pl}_${Channel}_${tmpl}`;
    label += SCN ? `_${SCN}` : '';
    label += SubSCN ? `_${SubSCN}` : '';
    label += LastSubSCN ? `_${LastSubSCN}` : '';
    const obj = {
      event: e || 'user_shown',
      type: `${tmplSrc}_${t}`,
      label,
    };
    if (c) {
      obj.category = c;
    }
    analyticsWrapper('ga4', obj);
  };
}

export function sharePropsToPlayer(props, jminitv) {
  const {
    videoId,
    videoInloop,
    shareUrl,
    adSection,
    bl,
    midfreq,
    updateConfig = {},
    skipAds,
    tmplSource,
    skipAnalytics = false,
    imageid,
    splId,
  } = jminitv;

  const { isMobile, isPrime, isEtimes } = props;

  return {
    slikeId: videoId,
    videoInloop: videoInloop === '1',
    shareUrl,
    adSection,
    tplId: tmplSource,
    bl,
    midfreq,
    isVideoSkipAds: skipAds === '1',
    skipAnalytics,
    config: updateConfig,
    isMobile,
    isPrime,
    isEtimes,
    imageid,
    splId,
  };
}

export const getInitState = (layoutSsConfig, layoutConfig) => {
  const { layoutType } = layoutSsConfig;
  const { initialDock, headless } = layoutConfig;
  const layoutbasedstate = getDynLayoutConfig(layoutType);
  return {
    ...layoutbasedstate,
    layoutType,
    isDock: initialDock,
    showTimer: false,
    overlayBtn: false,
    showClientUI: false,
    play: 0,
    mute: true,
    playerControls: !headless,
  };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'update':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export const debounce = (func, delay = 10) => {
  let timer;
  let frameId;

  const debouncedFunction = function(...args) {
    const context = this; // Preserve `this` context

    if (frameId) cancelAnimationFrame(frameId);
    clearTimeout(timer);

    frameId = requestAnimationFrame(() => {
      timer = setTimeout(() => func.apply(context, args), delay);
    });
  };

  debouncedFunction.cancel = () => {
    if (frameId) cancelAnimationFrame(frameId);
    clearTimeout(timer);
  };

  return debouncedFunction;
};
export function onScrollTriggerOnce(scrollPixels, callback) {
  let handleScroll;
  function scrollHandler() {
    if (window.scrollY >= scrollPixels) {
      callback();
      window.removeEventListener('scroll', handleScroll); // Remove listener after trigger
      handleScroll.cancel();
    }
  }
  handleScroll = debounce(() => {
    scrollHandler();
  }, 10);

  window.addEventListener('scroll', handleScroll);
}
